import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/pt-br";

dayjs.extend(relativeTime);
dayjs.locale("pt-br");

const AVATAR_COLORS = [
  "var(--seed-base)",
  "var(--status-info)",
  "var(--status-success)",
  "var(--status-warning)",
  "#6366f1",
  "#8b5cf6",
  "#ec4899",
  "#14b8a6",
];

/**
 * Extracts a display name from an email address.
 * e.g. "lucas@k4d.com.br" -> "Lucas"
 *      "joao.silva@k4d.com.br" -> "Joao Silva"
 */
export function formatNoteAuthor(email: string): string {
  const local = email.split("@")[0] ?? email;
  return local
    .split(/[._-]/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

/**
 * Returns initials (up to 2 chars) from an email address.
 * e.g. "lucas@k4d.com.br" -> "L"
 *      "joao.silva@k4d.com.br" -> "JS"
 */
export function getAuthorInitials(email: string): string {
  const parts = email.split("@")[0]?.split(/[._-]/) ?? [];
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  }
  return (parts[0]?.[0] ?? "?").toUpperCase();
}

/**
 * Deterministic color from email for avatar background.
 */
export function getAuthorColor(email: string): string {
  let hash = 0;
  for (let i = 0; i < email.length; i++) {
    const code = email.charCodeAt(i);
    hash = hash * 31 + code;
    hash |= 0;
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]!;
}

/**
 * Formats a note's created_at timestamp as a relative time string.
 * e.g. "há 3 minutos", "há 2 dias"
 */
export function formatNoteDate(isoDate: string): string {
  return dayjs(isoDate).fromNow();
}
